module.exports = __webpack_public_path__ + "static/media/macBook-small.0bf60ab9.jpg";